module.exports = __webpack_public_path__ + "img/badge-soingant.c2f5aab7.png";